import type { CreativePayloadEntry } from '../api/types';

export type AdSettingFieldId = string | number;

export type AdSettingsFieldValue = Record<'page_id' | 'text_id', AdSettingFieldId>;

export type AdSettingsFields = Record<string, AdSettingsFieldValue>;

export interface CreativePackEntry {
  tag: string;
  ad_type: string;
  creatives: CreativePayloadEntry[];
  visual_touch_ups?: boolean;
  ad_settings?: AdSettingsFields;
}

export enum PartnershipIdentityToShow {
  BOTH = 'BOTH',
  FIRST_ONLY = 'FIRST_ONLY',
  DYNAMIC = 'DYNAMIC',
}

export enum PartnershipCreationMode {
  PARTNERSHIP_ONLY = 'PARTNERSHIP_ONLY',
  BOTH = 'BOTH',
}

export type PartnershipAdSettingsFieldValue = AdSettingsFieldValue;

export type PartnershipAdSettingsFields = AdSettingsFields;

export interface PartnershipAdSettingItem {
  partner_page_id: string;
  partner_instagram_id: string | null;
  is_partner_identity_first: boolean;
  identity_to_show: PartnershipIdentityToShow;
  creation_mode: PartnershipCreationMode;
  tag: string;
  ad_settings: PartnershipAdSettingsFields;
}

export type PartnershipAdSettingsPayload = PartnershipAdSettingItem[];
